import React from 'react';

interface Props extends React.PropsWithChildren {
  on?: boolean | string | number | object;
  when?: boolean | string | number | object;
}

/*
    Simple visibility component
    Usage:
        <Show on={true} >Hello world!</Show>
*/
export const Show = (props: Props) => {
  return !props.on && !props.when ? null : <>{props.children}</>;
};
